export enum ERole {
  CLIENT = 'CLIENT',
  WORKER = 'WORKER',
  MANAGER = 'MANAGER',
  OWNER = 'OWNER',
  ADMIN = 'ADMIN',
  DRIVER = 'DRIVER',
}
